import LocalNotification from '@libs/Notification/LocalNotification';
import type ClearReportNotifications from './types';

const clearReportNotifications: ClearReportNotifications = LocalNotification.clearReportNotifications;
export default clearReportNotifications;
